<template>
  <NodeViewWrapper class="my-4 rounded-2xl border p-4" :class="style.box">
    <div class="mb-2 flex items-center gap-2" contenteditable="false">
      <iconify-icon :icon="style.icon" class="text-lg" :class="style.ink" aria-hidden="true" />
      <select
        :value="node.attrs.kind"
        class="rounded-md bg-transparent text-[11px] font-bold uppercase tracking-widest outline-none"
        :class="style.ink"
        aria-label="Kind of note"
        :disabled="!editor.isEditable"
        @change="updateAttributes({ kind: $event.target.value })"
      >
        <option v-for="(kind, key) in CALLOUTS" :key="key" :value="key">{{ kind.label }}</option>
      </select>
    </div>
    <NodeViewContent class="callout-body text-[15px] leading-relaxed text-[#1c4848]" />
  </NodeViewWrapper>
</template>

<script setup>
import { computed } from 'vue';
import { NodeViewContent, NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';
import { CALLOUTS } from '@/components/writer/reader/callouts.js';

const props = defineProps(nodeViewProps);
const style = computed(() => CALLOUTS[props.node.attrs.kind] ?? CALLOUTS.note);
</script>
